'use strict';

import * as Props from '../Props';

const angular = require('angular');

const MapProperties = {
    Basic: {
        'ControlType': 'Map',
        'Label': {
            name: 'label',
            selectedValue: 'Map',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('Map'),
        'Data Field Name': Props.getDataFieldName('Map'),
        'Default': {
            type: 'textbox',
            name: 'default',
            disable: true,
            selectedValue: ''
        },
        'Type': {
            name: 'type',
            type: 'dd',
            options: [
                {
                    value: '36',
                    key: 'Ordnance Survey Grid Reference'
                }, {
                    value: '35',
                    key: 'Geo Cordinates'
                }],
            selectedValue: '35',
            onChangeFunction: 'mapTypeChanged'
        },
        'Required': {
            name: 'required',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        }
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: angular.copy(Props.controlStyleObject),
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Searchable': angular.copy(Props.Searchable),
        'Reportable': angular.copy(Props.Reportable),
        'customizable-column': angular.copy(Props.Customizable),
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    },
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load,
        change: angular.copy(Props.elementEventsObject).change
    }
};

export default MapProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Map.ts